import {
  MultiTextAutocompleteInput,
  type MultiTextAutocompleteInputProps,
} from 'components/MultiTextAutocompleteInput/MultiTextAutocompleteInput';

export type TagNameInputProps = Omit<
  MultiTextAutocompleteInputProps,
  'allowFreeText'
>;

/**
 * Tag-name picker for `cloudResourceTag` rules.
 *
 * Free text, not a closed picker: global settings are configured before any
 * snapshot exists, so discovered names are only a convenience. Order matters —
 * it is the rule's first-match-wins priority.
 */
export const TagNameInput = ({
  dataTestId = 'site-separation-tag-names-input',
  placeholder = 'Enter a tag name and press Enter',
  ...props
}: TagNameInputProps) => (
  <MultiTextAutocompleteInput
    {...props}
    dataTestId={dataTestId}
    placeholder={placeholder}
  />
);
